import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import React, { useCallback } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/auth';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import LogoutTimer from './LogoutTimer';
//import { useAuth } from './contexts/auth';
import { licenseKey } from './devextreme-license';
import config from 'devextreme/core/config'
// import dotenv from 'dotenv';
// dotenv.config();

config({
  licenseKey
})



function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}



export default function Root() {
  const screenSizeClass = useScreenSizeClass();
  // Define logoutCallback function
  const logoutCallback = () => {

    // Function to clear localStorage
    const clearLocalStorage = () => {
      localStorage.clear();
    };

    // Call the clearLocalStorage function when useAuth is invoked
    //sessionStorage.setItem('lastVisitedRoute', window.location.pathname);
    clearLocalStorage();
    //sessionStorage.clear();
    window.location.reload();
  };

  console.log(process.env.REACT_APP_BASE_URL);

  return (
    <Router>
      <AuthProvider
        authType={"cookie"}
        authName={"_auth"}
        cookieDomain={window.location.hostname}
        cookieSecure={false}
      >
        <NavigationProvider>
          <div className={`app ${screenSizeClass}`}>
            {/* Include the LogoutTimer component */}
            <LogoutTimer logoutCallback={logoutCallback} />
            <App />
          </div>
        </NavigationProvider>
      </AuthProvider>
    </Router>
  );
}
